import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [  "content", "buttons", "showMore", "showLess"  ]

  connect() {
    if (!this.isContentTruncated()) { this.buttonsTarget.classList.add("d-none") }
  }

  isContentTruncated() {
    return this.contentTarget.offsetHeight < this.contentTarget.scrollHeight ||
      this.contentTarget.offsetWidth < this.contentTarget.scrollWidth
  }

  toggle(event) {
    // Prevent the click from bubbling to an ancestor row/link handler
    // (e.g. the clickable back-office table rows) so it only toggles.
    event?.preventDefault()
    event?.stopPropagation()

    if (this.contentTarget.classList.contains("c--see-more-text__hide-overflow")) {
    this.contentTarget.classList.remove("c--see-more-text__hide-overflow")
    this.showMoreTarget.classList.add("d-none")
    this.showLessTarget.classList.remove("d-none")
    } else {
      this.contentTarget.classList.add("c--see-more-text__hide-overflow")
      this.showMoreTarget.classList.remove("d-none")
      this.showLessTarget.classList.add("d-none")
    }
  }
}
